(function () {
    'use strict';

    angular
        .module('tfc.retailer.Filter')
        .controller('FilterCtrl', filterCtrl);

    function filterCtrl(GaUtil) {
        var vm = this;
        var filter = vm.filter;

        filter.setBrandKey(vm.selectedBrand.key);
        vm.data = filter.getData();

        vm.optionString = filter.getOptionString();
        vm.onChange = function () {
            filter.setSelectedItem(vm.selectedItem);
            var evt = filter.getEventDetails();
            GaUtil.sendGaEvent(evt.eventCategory, evt.eventAction, evt.eventLabel);
            vm.reload();
        };

        vm.isVisible = filter.isVisible();

        vm.isDisabled = filter.isDisabled();

        vm.selectedItem = filter.getSelectedItem();
    }

}());

